//@ts-ignore
import {
  AccessControl,
  ClientAccessControl,
} from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { Popover, Transition } from "@headlessui/react";
import { MenuIcon } from "@heroicons/react/outline";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { isMobile } from "react-device-detect";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import APIS from "../constant/Endpoint";
import useGetHook from "../customHooks/useGetHook";
import useNoticePostHook from "../customHooks/useNoticePostHook";
import { getKey, setKey } from "../helpers/sessionKey";
import { classNames, responsiveClassName } from "../utils/classNames";
import Logout from "./Logout";
import Modal from "./Modal";
import NoticeModal from "./NoticeModal";
import NoticePopup from "./NoticePopup";
import Notification from "./Notification";
import NotificationContextProvider from "./Notification/context";
import ServiceList from "./ServiceList";
import SetupBranch from "./SetupBranch";
import Sidebar from "./Sidebar";
import SearchIcon from "../Icons/SearchIcon";
import { useForm } from "react-hook-form";
import SwitchCompany from "./SwitchCompany";
import CallIcon from "../Icons/CallIcon";
import { postApiData } from "../helpers/AxiosInstance";
import { toast } from "react-toastify";
import QRCode from "react-qr-code";
import QrIcon from "../Icons/QrIcon";
import { parseFonepayQR } from "../helpers/fonePayQr";
import TabPanel from "../Reusable/Tab/index";
import esewa from "../assets/paymentsLogos/esewa1.png";
import khalti from "../assets/paymentsLogos/khaltiLogo-1.png";

interface DashboardLayoutProps {
  children: React.ReactNode;
  navigation: {
    name: string;
    href: string;
    icon: React.ReactNode;
    children: {
      name: string;
      href: string;
      icon: React.ReactNode;
      activeIcon: React.ReactNode;
    }[];
  }[];
}
const safeParse = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const DashboardLayout = ({ children, navigation }: DashboardLayoutProps) => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openNoticePopup, setOpenNoticePopup] = useState(false);
  const [currentNoticeIndex, setCurrentNoticeIndex] = useState(0);
  const [qrImage, setQrImage] = useState<string | null>(null);
  const location = useLocation();
  const [openSwitchPopup, setOpenSwitchPopup] = useState(false);
  const [openQrUploadPopup, setOpenQrUploadPopup] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const handleSearch = (data: any) => {
    if (!data?.search) return;
    searchParams.set("searchQuery", data?.search);
    const newUrl = `order#/list?${searchParams.toString()}`;
    window.location.replace(newUrl);
  };
  const searchQuery = searchParams.get("searchQuery");

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: async () => {
      return {
        search: searchQuery,
      };
    },
  });

  // const { data: userProfileType } = useGetHook({
  //   queryKey: [`user-profile`],
  //   url: `${APIS.USER_PROFILE}`,
  //   params: {},
  // });
  const { data: ActiveNoticeData } = useGetHook({
    queryKey: [`active-notice`],
    url: `${APIS.ACTIVE_NOTICE}`,
    params: {},
  });

  const { mutateAsync: RecordNoticemutateAsync, isPostLoading } =
    useNoticePostHook({
      queryKey: ["record-notice"],
    });

  const handleClosePopup = () => {
    const Notice =
      Array.isArray(ActiveNoticeData) && ActiveNoticeData.length > 0
        ? ActiveNoticeData?.[currentNoticeIndex]
        : null;
    if (currentNoticeIndex < ActiveNoticeData.length - 1) {
      setCurrentNoticeIndex(currentNoticeIndex + 1);
      if (Notice?.id) {
        handleViewedNotice(Notice?.id);
      }
    } else {
      if (Notice?.id) {
        handleViewedNotice(Notice?.id);
      }
      setOpenNoticePopup(false);
    }
  };
  const { data: clietData, isLoading } = useGetHook({
    queryKey: [`client-setting`],
    url: APIS.CLIENT_SETTING,
    params: {},
  });
  useEffect(() => {
    if (clietData) {
      document.title = clietData?.business_name;
      const favicon =
        (document.querySelector("link[rel='icon']") as HTMLLinkElement) ||
        (document.createElement("link") as HTMLLinkElement);
      favicon.rel = "icon";
      favicon.href = clietData?.favicon_icon;
      if (!document.querySelector("link[rel='icon']")) {
        document.head.appendChild(favicon);
      }
    }
  }, [clietData]);

  const { data: profile, isLoading: isprofiledataLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const { data: clientData, isLoading: isClientDataLoading } = useGetHook({
    queryKey: [`client-type`],
    url: `${APIS.CLIENT_TYPE}`,
    params: {},
  });

  const handleViewedNotice = useCallback(
    async (id: any) => {
      let formData = {
        notice: id,
      };
      const url = APIS.RECORD_NOTICE;
      try {
        await RecordNoticemutateAsync({ url, formData });
      } catch (err) {
        console.log(err);
      }
    },
    [RecordNoticemutateAsync]
  );

  useEffect(() => {
    if (Array.isArray(ActiveNoticeData) && ActiveNoticeData.length > 0) {
      ActiveNoticeData?.map((item: any, index: number) => {
        if (item?.type === "alert") {
          alert(`${item?.title} - ${item?.content}`);
          handleViewedNotice(item?.id);
        } else {
          setOpenNoticePopup(!openNoticePopup);
        }
      });
    }
  }, [ActiveNoticeData, handleViewedNotice]);

  useEffect(() => {
    if (profile) {
      setKey("user", profile.id);
      setKey("is_staff", profile.is_staff);
      setKey("is_superuser", profile.is_superuser);
      setKey("default-branch", JSON.stringify(profile.default_branch));
    }

    if (clientData?.type) {
      setKey("client-type", clientData.type);
    }
  }, [profile, clientData, setKey]);

  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "m") {
        navigate("/home");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  const defaultBranch = profile?.default_branch?.id;
  const { data: bankDetail } = useGetHook({
    queryKey: ["bank-detail", defaultBranch],
    url: APIS.BANK_DETAIL,
    params: {
      object_id: defaultBranch,
    },
    enabled: !!defaultBranch,
  });

  const bank = bankDetail?.[0];
  const qrText = JSON.stringify({
    bank_name: bank?.bank_name,
    account_number: bank?.account_number,
    beneficiary: bank?.beneficiary,
    address: bank?.address,
  });

  const qrData = bankDetail?.[0]?.payment_detail?.fonepay;

  const esewaRaw = bankDetail?.[0]?.payment_detail?.esewa;
  const khaltiRaw = bankDetail?.[0]?.payment_detail?.khalti;

  const esewaData = safeParse(esewaRaw);
  const khaltiData = safeParse(khaltiRaw);

  const parsedData = useMemo(() => {
    return qrData ? parseFonepayQR(qrData) : {};
  }, [qrData]);

  return (
    <>
      <div className={tw`flex h-[100vh] overflow-hidden`}>
        <div
          className={classNames(
            openSidebar
              ? tw`block  transform  transition-transform duration-300 ease-in-out `
              : tw`hidden`,
            responsiveClassName(
              "h-full fixed top-0 bottom-0 z-[20] w-full",
              "h-full w-[18rem] hidden "
            )
          )}
        >
          <div
            className={responsiveClassName(
              "h-[65px] w-full bg-primary flex items-center justify-between px-4",
              "h-[65px] w-full bg-primary flex items-center justify-center px-4"
            )}
          >
            {isLoading ? (
              <div className={tw`h-12`} />
            ) : (
              <Link
                to={"/"}
                className={tw`h-14 w-40 filter bg-white p-1  cursor-pointer focus:outline-none`}
              >
                <img
                  className={tw`h-full w-full object-contain`}
                  src={clietData?.logo}
                  alt={clietData?.business_name}
                />
              </Link>
            )}

            <button
              className={responsiveClassName(
                "block focus:outline-none",
                "hidden focus:outline-none"
              )}
              onClick={() => setOpenSidebar(!openSidebar)}
            >
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="13" cy="13" r="12" fill="white" />
                <circle
                  cx="13"
                  cy="13"
                  r="12.25"
                  stroke="#535353"
                  stroke-opacity="0.6"
                  strokeWidth="0.5"
                />
                <path
                  d="M17.6773 9.19206L14.0407 12.8286L17.6773 16.4652L16.4651 17.6773L12.8285 14.0408L9.19199 17.6773L7.97981 16.4652L11.6164 12.8286L7.97981 9.19206L9.19199 7.97988L12.8285 11.6164L16.4651 7.97988L17.6773 9.19206Z"
                  fill="#535353"
                />
              </svg>
            </button>
          </div>
          <div className={tw`h-[calc(100%-65px)] p-1 hover:overflow-auto `}>
            <div
              className={responsiveClassName(
                "rounded-md h-full overflow-auto bg-white",
                "rounded-md h-full overflow-auto px-2 bg-gradient-to-b from-primary-light"
              )}
            >
              <ul>
                {navigation?.map((item, index: number) => (
                  <li
                    key={item.name}
                    onClick={() => setOpenSidebar(!openSidebar)}
                    role="menuitem"
                    tabIndex={0}
                  >
                    <span
                      className={tw`pt-2 block font-[18px] mt-6 text-gray-500`}
                    >
                      {item.name}
                    </span>
                    {item.children.length && (
                      <>
                        <ul className={tw`ml-2`}>
                          {item.children.map((subMenu, subIndex: number) => (
                            <React.Fragment key={`subIndex-${subMenu.href}`}>
                              <NavLink
                                key={`${subMenu.href}`}
                                to={subMenu.href}
                                className={({ isActive, isPending }) =>
                                  tw`${
                                    isActive
                                      ? tw`bg-primary-active rounded text-text-primary`
                                      : isPending
                                      ? tw`text-indigo-100 hover:bg-indigo-600`
                                      : ""
                                  } text-gray-700 my-1 cursor-pointer px-2 py-[4px] flex `
                                }
                              >
                                {/* @ts-ignore */}
                                <subMenu.icon
                                  color={
                                    location.pathname === subMenu.href
                                      ? "var(--primary)"
                                      : "gray"
                                  }
                                  c
                                />
                                <span className={tw`ml-4`}>{subMenu.name}</span>
                              </NavLink>
                            </React.Fragment>
                          ))}
                        </ul>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className={tw`h-full w-full`}>
          <div
            className={tw`h-[65px] w-full bg-primary flex justify-between items-center`}
          >
            <div className={tw``}>
              <div
                className={responsiveClassName(
                  " hidden",
                  "h-[65px] w-full bg-primary flex items-center justify-center py-2 relative"
                )}
              >
                {isLoading ? (
                  <div className={tw`h-16 w-[13rem]`} />
                ) : (
                  <Link
                    to={"/"}
                    className={tw`h-16 w-[13rem] p-1  flex items-center justify-center filter bg-white   cursor-pointer focus:outline-none`}
                  >
                    <img
                      className={tw`h-full w-full object-contain`}
                      src={clietData?.logo}
                      alt={clietData?.business_name}
                    />
                  </Link>
                )}
                <div
                  className={classNames(
                    isMobile ? tw`hidden` : tw`block w-6 ml-4 `
                  )}
                >
                  <button
                    className={classNames(
                      tw`w-6 h-10 mx-auto text-white focus:outline-none `
                    )}
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                  >
                    <MenuIcon />
                  </button>
                </div>
                <div
                  className={tw`absolute -right-[135px] bottom-[24px] cursor-pointer`}
                >
                  <a
                    href={`tel:${
                      profile?.default_branch?.primary_contact ??
                      "+977-0000000000"
                    }`}
                    className={tw`flex flex-row gap-1 items-center text-white no-underline`}
                  >
                    <CallIcon color="white" height={17} width={17} />
                    <p className={tw`text-bold`}>
                      {profile?.default_branch?.primary_contact ??
                        "+977-0000000000"}
                    </p>
                  </a>
                </div>
              </div>
              <button
                onClick={() => setOpenSidebar(!openSidebar)}
                className={responsiveClassName(
                  "block focus:outline-none",
                  "hidden focus:outline-none"
                )}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 12H21M3 6H21M3 18H21"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <ClientAccessControl allowedPermissions={["can_view_search"]}>
              <form onSubmit={handleSubmit((data) => handleSearch(data))}>
                <div
                  className={tw`flex w-96 items-center bg-white rounded-md overflow-hidden`}
                >
                  <input
                    className={tw`w-full px-2 rounded focus:outline-none bg-white h-8 `}
                    type="text"
                    {...register("search")}
                    placeholder="Search Shipment..."
                  />
                  <button
                    className={tw`bg-gray-300 px-2 py-1 focus:outline-none`}
                  >
                    <SearchIcon />
                  </button>
                </div>
              </form>
            </ClientAccessControl>

            <div className={tw`flex flex-row gap-x-2 items-center mr-2`}>
              <ClientAccessControl
                allowedPermissions={["can_view_notifications"]}
              >
                <div className="flex flex-row gap-2">
                  {bankDetail?.[0] && (
                    <div
                      className={tw`text-center flex items-center text-white cursor-pointer`}
                      onClick={() => setOpenQrUploadPopup(true)}
                    >
                      <QrIcon />
                    </div>
                  )}

                  <NotificationContextProvider>
                    <Notification />
                  </NotificationContextProvider>
                </div>
              </ClientAccessControl>
              {profile?.is_staff || profile?.is_superuser ? (
                <ClientAccessControl allowedPermissions={["can_view_services"]}>
                  <div className={tw`max-w-sm px-4`}>
                    <Popover className={tw`relative`}>
                      {({ open }) => (
                        <>
                          <Popover.Button
                            className={tw`
                ${open ? tw`text-white` : tw`text-white`}
                group inline-flex items-center rounded-md   py-2 text-base font-medium hover:text-white focus:outline-none `}
                          >
                            <svg
                              width="44"
                              height="44"
                              viewBox="0 0 44 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M22 16C22.5523 16 23 15.5523 23 15C23 14.4477 22.5523 14 22 14C21.4477 14 21 14.4477 21 15C21 15.5523 21.4477 16 22 16Z"
                                stroke="#FEFEFE"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M29 16C29.5523 16 30 15.5523 30 15C30 14.4477 29.5523 14 29 14C28.4477 14 28 14.4477 28 15C28 15.5523 28.4477 16 29 16Z"
                                stroke="#FEFEFE"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M15 16C15.5523 16 16 15.5523 16 15C16 14.4477 15.5523 14 15 14C14.4477 14 14 14.4477 14 15C14 15.5523 14.4477 16 15 16Z"
                                stroke="#FEFEFE"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M22 23C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21C21.4477 21 21 21.4477 21 22C21 22.5523 21.4477 23 22 23Z"
                                stroke="#FEFEFE"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M29 23C29.5523 23 30 22.5523 30 22C30 21.4477 29.5523 21 29 21C28.4477 21 28 21.4477 28 22C28 22.5523 28.4477 23 29 23Z"
                                stroke="#FEFEFE"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M15 23C15.5523 23 16 22.5523 16 22C16 21.4477 15.5523 21 15 21C14.4477 21 14 21.4477 14 22C14 22.5523 14.4477 23 15 23Z"
                                stroke="#FEFEFE"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M22 30C22.5523 30 23 29.5523 23 29C23 28.4477 22.5523 28 22 28C21.4477 28 21 28.4477 21 29C21 29.5523 21.4477 30 22 30Z"
                                stroke="#FEFEFE"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M29 30C29.5523 30 30 29.5523 30 29C30 28.4477 29.5523 28 29 28C28.4477 28 28 28.4477 28 29C28 29.5523 28.4477 30 29 30Z"
                                stroke="#FEFEFE"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M15 30C15.5523 30 16 29.5523 16 29C16 28.4477 15.5523 28 15 28C14.4477 28 14 28.4477 14 29C14 29.5523 14.4477 30 15 30Z"
                                stroke="#FEFEFE"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </Popover.Button>

                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                          >
                            <Popover.Panel
                              className={tw`absolute z-10 mt-3  max-w-sm w-[350px] px-4 -mx-[140px]`}
                            >
                              <ServiceList />
                            </Popover.Panel>
                          </Transition>
                        </>
                      )}
                    </Popover>
                  </div>
                </ClientAccessControl>
              ) : (
                ""
              )}
              <div className={tw`text-white flex relative`}>
                <div
                  className={tw`flex justify-center items-center whitespace-nowrap`}
                >
                  <span className={tw`text-[10px] mr-2 block text-right`}>
                    <ClientAccessControl
                      allowedPermissions={["can_view_profile"]}
                    >
                      <span className={tw`block capitalize`}>
                        {profile?.name ?? "N/A"}
                      </span>
                      {profile && (
                        <span className={tw`block`}>
                          {profile?.is_superuser
                            ? "Super Admin"
                            : profile?.is_rider
                            ? "Rider"
                            : profile?.is_staff
                            ? "Staff"
                            : "Merchant"}
                        </span>
                      )}
                    </ClientAccessControl>
                    <ClientAccessControl
                      allowedPermissions={["can_view_profile_branch"]}
                    >
                      <AccessControl
                        allowedPermissions={["can_update_profile_branch"]}
                        renderNoAccess={
                          <button
                            className={tw`cursor-pointer focus:outline-none text-right w-full flex justify-end `}
                            type="button"
                            disabled={!profile?.is_superuser}
                          >
                            <span>
                              {profile?.default_branch?.name?.length
                                ? profile?.default_branch?.name
                                : "N/A"}
                            </span>
                          </button>
                        }
                      >
                        <button
                          className={tw`cursor-pointer focus:outline-none text-right w-full flex justify-end `}
                          onClick={() => setOpenModal(!openModal)}
                        >
                          <span>
                            {profile?.default_branch?.name?.length
                              ? profile?.default_branch?.name
                              : "N/A"}
                          </span>
                        </button>
                      </AccessControl>
                    </ClientAccessControl>
                  </span>
                </div>
                <div className="">
                  <Logout
                    profile={profile}
                    setOpenSwtichPopup={setOpenSwitchPopup}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={tw`h-[calc(100%-95px)] flex  flex-row`}>
            {navigation ? (
              <Sidebar navigation={navigation} isSidebarOpen={isSidebarOpen} />
            ) : null}
            <div className={tw`w-full overflow-y-auto`}>{children}</div>
          </div>
          <div
            className={tw`h-[30px] w-full text-gray-700 flex items-center  bg-primary p-2 justify-center absolute`}
          >
            <h1>© {clietData?.business_name}</h1>
          </div>
        </div>
      </div>
      {/* {userProfileType?.is_merchant ? (
        <MerchantSupportButton profile={profile} />
      ) : isprofiledataLoading ? (
        <Spinner />
      ) : (
        <div className={tw`h-full `}>
          <FloatingButton profile={profile} isLoading={isprofiledataLoading} />
        </div>
      )} */}

      <Modal
        isOpen={openModal}
        setIsOpen={setOpenModal}
        title={"Select Default Branch"}
        children={<SetupBranch setOpenModal={setOpenModal} profile={profile} />}
      />
      <Modal
        isOpen={openSwitchPopup}
        setIsOpen={setOpenSwitchPopup}
        title={"Switch Company"}
        children={
          <SwitchCompany setOpenModal={setOpenSwitchPopup} profile={profile} />
        }
      />
      <Modal
        title={"Scan QR to Pay"}
        isOpen={openQrUploadPopup}
        setIsOpen={setOpenQrUploadPopup}
      >
        <TabPanel
          tabTitle={["fonePay", "esewa", "khalti", "Bank Details"]}
          tabPanels={[
            <div>
              <div
                className={tw`flex flex-col items-center justify-center min-h-[55vh] bg-white text-center px-4 `}
              >
                <h2 className={tw`text-xl font-semibold mb-2`}>We Accept</h2>
                <div className={tw`flex items-center mb-2`}>
                  <span
                    className={tw`text-white bg-red-600 px-2 py-1 rounded text-4xl font-bold`}
                  >
                    fone
                  </span>
                  <span className={`text-black text-4xl font-bold ml-1`}>
                    pay
                  </span>
                </div>
                <p className={tw`text-gray-600 mb-2 font-bold text-lg`}>
                  नेपाल राष्ट्र बैंकबाट अनुमति प्राप्त
                </p>
                <div className={tw`mt-4 w-full flex justify-center`}>
                  <QRCode
                    value={`${bankDetail?.[0]?.payment_detail?.fonepay}`}
                    size={250}
                    className={tw`bg-white p-4 rounded`}
                  />
                </div>
                <h3 className={tw`text-2xl font-bold mt-2 mb-2 text-gray-800`}>
                  {parsedData?.companyName}
                </h3>

                <p className={tw`text-gray-600`}>
                  Terminal: {parsedData?.accountNumber}
                </p>

                <p className={tw`text-gray-600 mb-8`}>
                  Address: {parsedData?.address}
                </p>
              </div>
              <div className={tw`flex justify-center items-center  `}>
                <div className={tw`w-full flex rounded-lg overflow-hidden`}>
                  <div
                    className={tw`w-1/2 bg-red-600 p-1 text-left text-white flex items-center`}
                  >
                    <span
                      className={tw`bg-white text-red-600 rounded-full w-8 h-8 flex items-center justify-center mr-3 font-bold flex-shrink-0`}
                    >
                      1
                    </span>
                    <p className={tw`text-sm leading-relaxed`}>
                      Open your fonepay Member Mobile Banking app / Digital
                      Wallet / Union pay
                    </p>
                  </div>
                  <div
                    className={tw`w-1/2 bg-gray-300 p-2 text-left text-gray-800 flex items-center`}
                  >
                    <span
                      className={tw`bg-white text-red-600 rounded-full w-8 h-8 flex items-center justify-center mr-3 font-bold flex-shrink-0`}
                    >
                      2
                    </span>
                    <p className={tw`text-sm leading-relaxed`}>
                      Scan this code, confirm the payment details and make quick
                      payments.
                    </p>
                  </div>
                </div>
              </div>
            </div>,

            // <div
            //   className={tw`flex flex-col items-center justify-center min-h-[63vh] bg-white text-center px-4`}
            // >
            //   <div className={tw`mt-4 w-full flex justify-center`}>
            //     <QRCode
            //       value={`${bankDetail?.[0]?.payment_detail?.esewa}`}
            //       size={250}
            //       className={tw`bg-white p-4 rounded`}
            //     />
            //   </div>
            //   <div className={tw`flex items-center mb-2 mt-8`}>
            //     <img src={esewa} alt="esewa" height={200} width={200} />
            //   </div>
            //   <h3 className={tw`text-2xl font-bold mt-4 mb-1 text-gray-800`}>
            //     {bankDetail?.[0]?.payment_detail?.esewa &&
            //       JSON.parse(bankDetail[0]?.payment_detail?.esewa)?.name}
            //   </h3>
            //   <p className={tw`text-xl text-gray-800 font-semibold`}>
            //     {bankDetail?.[0]?.payment_detail?.esewa &&
            //       JSON.parse(bankDetail[0]?.payment_detail?.esewa)?.eSewa_id}
            //   </p>
            //   <p className={tw`text-gray-600 mt-4`}>
            //     Scan QR code to receive money
            //   </p>
            // </div>,
            <div
              className={tw`flex flex-col items-center justify-center min-h-[63vh] bg-white text-center px-4`}
            >
              <div className={tw`mt-4 w-full flex justify-center`}>
                <QRCode
                  value={esewaData?.eSewa_id || esewaRaw || ""}
                  size={250}
                  className={tw`bg-white p-4 rounded`}
                />
              </div>

              <div className={tw`flex items-center mb-2 mt-8`}>
                <img src={esewa} alt="esewa" height={200} width={200} />
              </div>

              <h3 className={tw`text-2xl font-bold mt-4 mb-1 text-gray-800`}>
                {esewaData?.name || "—"}
              </h3>

              <p className={tw`text-xl text-gray-800 font-semibold`}>
                {esewaData?.eSewa_id || esewaRaw || "—"}
              </p>

              <p className={tw`text-gray-600 mt-4`}>
                Scan QR code to receive money
              </p>
            </div>,

            // <div
            //   className={tw`flex flex-col items-center justify-center min-h-[63vh] bg-white text-center px-4`}
            // >
            //   <p className={tw`text-gray-600 mb-2 font-bold text-lg`}>
            //     नेपाल राष्ट्र बैंकबाट अनुमति प्राप्त
            //   </p>
            //   <div className={tw`flex items-center mb-3`}>
            //     <img src={khalti} alt="Khalti" height={200} width={200} />
            //   </div>
            //   <div className={tw`mt-4 w-full flex justify-center`}>
            //     <QRCode
            //       value={`${bankDetail?.[0]?.payment_detail?.khalti}`}
            //       size={250}
            //       className={tw`bg-white p-4 rounded`}
            //     />
            //   </div>
            //   {/* <h3 className={tw`text-2xl font-bold mt-8 mb-2 text-gray-800`}>
            //     {bankDetail?.[0]?.payment_detail?.khalti &&
            //       JSON.parse(bankDetail[0]?.payment_detail?.khalti)?.name}
            //   </h3> */}
            //   <div
            //     className={tw`bg-blue-100 text-blue-800 rounded-full px-4 py-2 mt-4`}
            //   >
            //     <p className={tw`text-sm`}>Scan QR code to receive money</p>
            //   </div>
            // </div>,
            <div
              className={tw`flex flex-col items-center justify-center min-h-[63vh] bg-white text-center px-4`}
            >
              <p className={tw`text-gray-600 mb-2 font-bold text-lg`}>
                नेपाल राष्ट्र बैंकबाट अनुमति प्राप्त
              </p>

              <div className={tw`flex items-center mb-3`}>
                <img src={khalti} alt="Khalti" height={200} width={200} />
              </div>

              <div className={tw`mt-4 w-full flex justify-center`}>
                <QRCode
                  value={khaltiData?.Khalti_ID || khaltiRaw || ""}
                  size={250}
                  className={tw`bg-white p-4 rounded`}
                />
              </div>

              <h3 className={tw`text-2xl font-bold mt-8 mb-2 text-gray-800`}>
                {khaltiData?.name || "—"}
              </h3>

              <p className={tw`text-xl text-gray-800 font-semibold`}>
                {khaltiData?.Khalti_ID || khaltiRaw || "—"}
              </p>

              <div
                className={tw`bg-blue-100 text-blue-800 rounded-full px-4 py-2 mt-4`}
              >
                <p className={tw`text-sm`}>Scan QR code to receive money</p>
              </div>
            </div>,

            <div
              className={tw`flex flex-col items-center justify-center min-h-[63vh] bg-gradient-to-br from-slate-50 to-slate-100 px-4 py-8`}
            >
              <div
                className={tw`w-full max-w-2xl bg-white rounded-2xl shadow-xl p-8`}
              >
                <div className={tw`mb-8 text-center`}>
                  <h2 className={tw`text-3xl font-bold text-slate-800 mb-2`}>
                    Bank Account Details
                  </h2>
                  <div
                    className={tw`w-20 h-1 bg-cyan-500 mx-auto rounded-full`}
                  ></div>
                </div>
                <div className={tw`space-y-6`}>
                  <div className={tw`grid grid-cols-1 md:grid-cols-2 gap-6`}>
                    <div
                      className={tw`bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-5 border border-cyan-100 shadow-sm hover:shadow-md transition-shadow duration-300`}
                    >
                      <div
                        className={tw`text-xs font-semibold text-cyan-600 uppercase tracking-wide mb-2`}
                      >
                        Account Name
                      </div>
                      <div className={tw`text-lg font-bold text-slate-800`}>
                        {parsedData?.companyName}
                      </div>
                    </div>

                    <div
                      className={tw`bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-5 border border-cyan-100 shadow-sm hover:shadow-md transition-shadow duration-300`}
                    >
                      <div
                        className={tw`text-xs font-semibold text-cyan-600 uppercase tracking-wide mb-2`}
                      >
                        Account Number
                      </div>
                      <div
                        className={tw`text-lg font-bold text-slate-800 font-mono`}
                      >
                        {bankDetail?.[0]?.account_number}
                      </div>
                    </div>
                  </div>

                  <div className={tw`grid grid-cols-1 md:grid-cols-2 gap-6`}>
                    <div
                      className={tw`bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-5 border border-cyan-100 shadow-sm hover:shadow-md transition-shadow duration-300`}
                    >
                      <div
                        className={tw`text-xs font-semibold text-cyan-600 uppercase tracking-wide mb-2`}
                      >
                        Address
                      </div>
                      <div
                        className={tw`text-lg font-bold text-slate-800 font-mono uppercase`}
                      >
                        {bankDetail?.[0]?.address}
                      </div>
                    </div>

                    <div
                      className={tw`bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-5 border border-cyan-100 shadow-sm hover:shadow-md transition-shadow duration-300`}
                    >
                      <div
                        className={tw`text-xs font-semibold text-cyan-600 uppercase tracking-wide mb-2`}
                      >
                        Bank Name
                      </div>
                      <div className={tw`text-lg font-bold text-slate-800`}>
                        {bankDetail?.[0]?.bank_name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>,
          ]}
        />
      </Modal>
      <NoticeModal
        isOpen={openNoticePopup}
        setIsOpen={handleClosePopup}
        title={"Notice"}
        children={
          <NoticePopup
            NoticeData={
              ActiveNoticeData ? ActiveNoticeData[currentNoticeIndex] : null
            }
          />
        }
      />
    </>
  );
};

export default DashboardLayout;
